import { getCoreSonarObjectsBulkPatchAsyncSlice } from './patch';

export const {
	requestPatchCoreSonarObjectsBulkPatch,
	resetPatchCoreSonarObjectsBulkPatch
} = getCoreSonarObjectsBulkPatchAsyncSlice.asyncActionCreators;
